/*
  Add new page?
  Do it here first:
  https://ghe.spotify.net/datainfra/page-identifier-schema/blob/bdaedf6249bccc7c326939f9cbf9184bddfa7005/schema/page_identifiers.yaml#L3655
 */

export enum PageId {
  Home = 'support-site/home',
  Category = 'support-site/category',
  Article = 'support-site/article',
  OldHome = 'support-site/old/home',
  OldChildCategory = 'support-site/childcategory',
  OldArticle = 'support-site/old/article',
  Contact = 'support-site/contact',
  OldContact = 'support-site/old/contact',
}
